<button
	matRipple
	class="Icon-button"
	[class.Icon-button--background]="hasBackground"
	[matTooltip]="hasTooltip"
	[matTooltipPosition]="tooltipPosition"
	[class.Icon-button--tiny]="buttonSize === EIconButtonSize.tiny"
	[class.Icon-button--small]="buttonSize === EIconButtonSize.small"
	[class.Icon-button--normal]="buttonSize === EIconButtonSize.normal"
	[class.Icon-button--medium]="buttonSize === EIconButtonSize.medium"
	[class.Icon-button--large]="buttonSize === EIconButtonSize.large"
	[class.Icon-button--red]="color === EButtonColor.red"
	[class.Icon-button--green]="color === EButtonColor.green"
	[class.Icon-button--inherit]="color === EButtonColor.inherit"
	[disabled]="isDisabled"
	[class.Icon-button--isDisabled]="isDisabled"
	(click)="emitClick()"
>
	<ng-content select="[appIcon]"></ng-content>
</button>
